import { ComponentPropsWithRef } from "react";
import styled, { keyframes } from "styled-components";

// TEXT

// STYLES
const pulse = keyframes`
  0%, 100% { opacity: 0.2; }
  50% { opacity: 1; }
`;

export const Dot = styled.circle<{ $delay: number }>`
  animation: ${pulse} 1.2s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}s;
`;

// DATA

// TYPES
export interface Props extends ComponentPropsWithRef<"svg"> {
  className?: string;
}

// FUNCTIONS

// ASSETS
